import React, { useEffect, useRef, useState } from "react";
import "../Styles/Results.css";

const Results = ({ scrollToSection }) => {
  const sectionRef = useRef(null);
  const [fromScore, setFromScore] = useState(47);
  const [toScore, setToScore] = useState(47);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;

    const duration = 1400;
    const start = performance.now();
    const fromStart = 47;
    const toEnd = 75;

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setFromScore(fromStart);
      setToScore(Math.round(fromStart + (toEnd - fromStart) * eased));
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }, [started]);

  return (
    <section className="results" ref={sectionRef}>
      <div className="container results-grid">
        <div className="results-copy reveal">
          <p className="eyebrow">Real parent results</p>
          <h2 className="section-title">
            Four tutors couldn’t reach him.
            <span> Ours did.</span>
          </h2>
          <p className="section-lead">
            Parents come to us after trying “more of the same.” The difference is a
            carefully matched tutor who finally connects — and progress you can see.
          </p>
          <blockquote className="results-quote">
            “…has a rare ability to connect in a way that four other tutors couldn’t.”
            <cite>— Parent of a 15-year-old, Math &amp; Science</cite>
          </blockquote>
          <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
            Book Their Free Consult
          </button>
        </div>

        <div className={`results-panel reveal ${started ? "is-live" : ""}`}>
          <div className="results-stars" aria-label="5 star Google reviews">
            <span>★★★★★</span>
            <p>Google reviews from Alberta parents</p>
          </div>
          <div className="results-scoreline">
            <span className="score from">{fromScore}%</span>
            <span className="score-arrow" aria-hidden="true">
              →
            </span>
            <span className="score to">{toScore}%</span>
          </div>
          <p className="results-time">In just three months.</p>
          <ul className="results-pillars">
            <li>Matched</li>
            <li>University-tutor led</li>
            <li>Alberta-based</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Results;
